export enum TickRange {
  Day = 'day',
  Week = 'week',
  Month = 'month',
  Months = 'months',
}
